import {Component, OnInit, AfterViewInit, AfterViewChecked, ViewChild, ElementRef, LOCALE_ID, ChangeDetectorRef} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {DataService} from '../../../../Services/data.service';
import {StorageService} from '../../../../Services/storage.service';
import {Title} from '@angular/platform-browser';
import {HttpErrorResponse} from '@angular/common/http';
import {BankReconciliationModel} from '../../../../DataModels/bank-reconciliation-model';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {DecimalPipe, DatePipe} from '@angular/common';
import {NavigationService} from '../../../../Services/navigation.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {CanComponentDeactivate} from '../../../../Interfaces/unsaved-changes.interface';
import {EmailService} from '../../../../Services/email.service';
import {EmailModel} from '../../../../DataModels/email-model';
import {ReportPrintService} from '../../../../Services/report-print.service';

@Component({
  selector: 'app-bank-reconciliation-form',
  templateUrl: './bank-reconciliation-form.component.html',
  styleUrls: ['./bank-reconciliation-form.component.css'],
  standalone: false
})
export class BankReconciliationFormComponent implements OnInit, AfterViewInit, AfterViewChecked, CanComponentDeactivate {
  @ViewChild('PrintRoot', {static: false}) PrintRoot: ElementRef;
  // @ViewChild('transaction') transactions: any;

  public vm: any = {
    clearedItems: 0.00,
    title: '',
    buttonsDisabled: true,
    dateError: false,
    Preferences: [],
  };

  bankReconciliationId: string;
  bankReconciliationCount = 0;
  bankReconciliationForm: UntypedFormGroup;
  reconRows: UntypedFormGroup;
  currency = [];
  bank = [];
  company = [];
  bankReconciliation: BankReconciliationModel;
  bankReconciliationData: any = [];
  bankReconItems = [];
  amountToReconcile = 0;
  amountRemainingToReconcile = 0;
  isBankLoaded = false;
  isLoaded = false;
  buttonConfig: any = {
    save: true,
    close: true,
    reset: false,
    delete: true,
    saveNew: false,
    saveClose: true,
    print: true,
    email: true,
  };

  reportDataToSendInEmail: EmailModel = new EmailModel();

  companyError;
  currencyError;
  currency_id;
  showDelete;
  clearedDate;
  bsConfig;
  clrDate = '';
  submitted = false;
  reconLineItems: UntypedFormArray;
  statementToBookVariance: any;
  totalWithdrawals = 0;
  totalDeposits = 0;
  deposit = 0;
  todayDate = this.dateFilter.GetDateFormat(new Date()).toString();
  isSaving = false;
  isDeleting = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private formBuilder: UntypedFormBuilder,
    public dateFilter: DateFilterService,
    private titleService: Title,
    private confirmDialogService: ConfirmDialogService,
    private decimalPipe: DecimalPipe,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private nav: NavigationService,
    private emailService: EmailService,
    private reportPrint: ReportPrintService,
  ) {
    // this.vm.bankTransactions = [];
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.bankReconciliationId = this.route.snapshot.params.id;
    });

    this.bankReconciliationForm = this.formBuilder.group({
      account_id: ['', Validators.required],
      reconciliation_date: [this.todayDate, Validators.required],
      balance: ['', Validators.required],
      company_id: [''],
      currency_id: [''],
      reconciled: [false],
      reconItems: this.formBuilder.array([]),
    });
  }

  originalDocument: any;

  checkForChanges(): boolean {
    return this.hasChanges();
  }

  ngOnInit() {
    this.bsConfig = {
      dateInputFormat: 'mm/dd/yyyy',
    };
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
      // console.log('id', this.bankReconciliationId);
      this.loadCurrency();
      this.loadBank();
      this.loadCompany();
      if (this.bankReconciliationId !== 'new') {
        this.loadBankReconciliation();
        this.bankReconciliationForm.get('account_id').disable();
      } else {
        this.isLoaded = true;
        // capture initial form snapshot for new reconciliation so the guard can detect changes
        this.originalDocument = structuredClone(this.bankReconciliationForm.getRawValue());
      }
      this.vm.title = $localize`:Bank Reconciliation @@bankReconciliation:Bank Reconciliation`;
      this.vm.buttonsDisabled = false;
      this.disablefields(false);
      this.reconLineItems = this.bankReconciliationForm.get('reconItems') as UntypedFormArray;
    });
  }

  ngAfterViewInit() {
    // this.titleService.setTitle(this.vm.title);
    this.titleService.setTitle($localize`:Bank Reconciliation@@bankReconciliation:Bank Reconciliation`);
  }

  ngAfterViewChecked() {
  }

  hasChanges(): boolean {
    try {
      const current =
        this.bankReconciliationForm?.getRawValue ? this.bankReconciliationForm.getRawValue() : this.bankReconciliationForm?.value;
      return JSON.stringify(current) !== JSON.stringify(this.originalDocument);
    } catch {
      return false;
    }
  }

  reconItems(): UntypedFormArray {
    const items = this.bankReconciliationForm.get('reconItems') as UntypedFormArray;
    // items.clear();
    return items;
  }

  getArrayControlValue(index: number, controlName: string): string {
    // console.log(index);
    const controlArray = this.bankReconciliationForm.get('reconItems') as UntypedFormArray;
    // console.log(controlName + ': ' + controlArray.controls[index].get(controlName).value);
    return controlArray.controls[index].get(controlName).value;
  }

  isValidInput(fieldName): boolean {
    return (
      this.bankReconciliationForm.controls[fieldName].invalid &&
      (this.bankReconciliationForm.controls[fieldName].dirty || this.bankReconciliationForm.controls[fieldName].touched)
    );
  }

  loadFormArray(data: any) {
    // clear old form if there are values - this is a reload
    if (this.bankReconciliationForm?.controls.reconItems?.value.length > 0) {
      // console.log('clearing form array');
      const myFormArray = this.bankReconciliationForm.get('reconItems') as FormArray;
      myFormArray.clear();
    }

    for (const item of data) {
      this.reconItems().push(this.newReconItemWithData(item));
    }
  }

  newReconItemWithData(data: any = null): UntypedFormGroup {
    // console.log ('create one row with these values: ' + JSON.stringify(data));
    data = data || {
      isReconciled: false,
      datePickerClearedDate: '',
      clearedId: '',
      enteredDate: '',
      detailId: '',
      deposit: '',
      withdrawal: '',
      header_id: '',
      detail_id: ''
    };

    if (data.cleared_date) {
      this.clrDate = this.datePipe.transform(data.cleared_date, 'MM/dd/yyyy');
    }
    this.reconRows = this.formBuilder.group({
      isReconciled: [!!data.cleared_date],
      datePickerClearedDate: [data.cleared_date ? this.datePipe.transform(data.cleared_date, 'MM/dd/yyyy') : data.cleared_date],
      clearedId: [data.cleared_id],
      enteredDate: [this.datePipe.transform(data.header_date, 'MM/dd/yyyy')],
      detailId: [data.detail_id],
      deposit: [data.debit_credit > 0 ? this.makeDecimal(data.debit_credit) : 0],
      withdrawal: [data.debit_credit < 0 ? this.makeDecimal((data.debit_credit * -1).toString()) : 0],
      header_id: [data.header_id],
      detail_id: [data.detail_id]
    });
    return this.reconRows;
  }

  makeDecimal(num: string): any {
    // console.log('make decimal: ' + num);
    return this.decimalPipe.transform(num, '1.2-2');
    // return num;
  }

  removeThousandsSeparator(str: string, marker: string): string {
    while (str.toString().search(marker) >= 0) {
      str = (str.toString() + '').replace(marker, '');
    }
    return str;
  }

  openRouteInNewTab(route: string) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([route])
    );
    window.open(url, '_blank');
  }

  /**
   * Print the Bank Reconciliation report using the hidden print section in the template.
   */
  printReport(): void {
    this.reportPrint.printInIframe(this.buildPrintHtml());
  }

  setEmailData(): void {
    const html = this.buildPrintHtml();
    const bankName = this.getBankAccountName();
    const reconDate = this.bankReconciliation?.reconciliation_date || '';
    this.reportDataToSendInEmail = {
      ...this.reportDataToSendInEmail,
      pdfHtml: html,
      Subject: `Bank Reconciliation${bankName ? ' - ' + bankName : ''}${reconDate ? ' - ' + reconDate : ''}`,
    };
  }

  private buildPrintHtml(): string {
    const rawContent = (this.PrintRoot?.nativeElement?.outerHTML || '').toString();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const bankName = this.getBankAccountName();
    const reconDate = this.bankReconciliation?.reconciliation_date || '';
    return this.reportPrint.buildHtml({
      title: 'Bank Reconciliation',
      contentHtml: content,
      meta: [
        ...(bankName ? [{label: 'Account', value: bankName}] : []),
        ...(reconDate ? [{label: 'Reconciliation Date', value: reconDate}] : []),
      ],
      orientation: 'portrait',
    });
  }

  /**
   * Safely determine if a recon item at index is marked reconciled.
   * Guards against undefined controls during early render or rebuilds.
   */
  isItemReconciled(index: number): boolean {
    const arr = this.bankReconciliationForm?.get('reconItems') as UntypedFormArray;
    if (!arr || index == null || index < 0 || index >= arr.length) {
      return false;
    }
    const group = arr.at(index) as UntypedFormGroup;
    return !!group?.get('isReconciled')?.value;
  }

  /**
   * Resolve the Bank Account name for header/report display.
   * Prefers values from loaded reconciliation payloads, falling back to the bank list by account_id.
   */
  getBankAccountName(): string {
    try {
      const fromRecon = this.bankReconciliation?.bank_name || this.bankReconciliation?.bank_name || '';
      const fromData = this.bankReconciliationData?.bank_name || this.bankReconciliationData?.account_name || '';
      const accountId = this.bankReconciliationForm?.get?.('account_id')?.value;
      const fromList = (this.bank || []).find((b: any) => b?.account_id === accountId)?.name || '';
      return fromRecon || fromData || fromList || '';
    } catch {
      return '';
    }
  }

  getDecimalSeparator(locale) {
    // a hack but reliable way to get separator
    if (locale === '') {
      locale = LOCALE_ID;
    }
    const numberWithDecimalSeparator = 1000.0;

    return numberWithDecimalSeparator.toLocaleString(locale).substring(1, 2);
  }

  loadBankReconciliation() {
    this.vm.buttonsDisabled = true;
    this.disablefields(true);
    this.vm.dateError = false;
    this.tableDataService.getData('bank_reconciliation', this.bankReconciliationId).subscribe({
      next: (result) => {
        // the existing recon data saved
        this.bankReconciliation = result;

        // recon saved transactions
        // this.bankTransactions = result.items;

        // this is the array they html reads from for th control iteration
        this.bankReconItems = result.items;

        this.bankReconciliationData = result;
        this.amountToReconcile = this.bankReconciliationData.endingBalance - this.bankReconciliationData.openingBalance;

        // balance to recs selected
        this.amountRemainingToReconcile = this.amountToReconcile;

        // console.log('transactions: ', this.bankReconItems);
        // console.log('transaction length: ', this.bankReconItems.length);

      },
      error: (error: HttpErrorResponse) => {
        console.log(error + ' - ' + $localize`:Error loading Bank Reconciliation @@errorloadingBankReconciliation:Error loading Bank Reconciliation`);
      },
      complete: () => {
        if (this.bankReconciliation.reconciliation_date) {
          this.bankReconciliation.reconciliation_date = this.dateFilter.GetDateFormat(
            this.bankReconciliation.reconciliation_date
          );
        }
        this.bankReconciliation.balance = this.removeThousandsSeparator(
          this.makeDecimal(this.bankReconciliation.balance),
          this.getDecimalSeparator(LOCALE_ID)
        );

        // format dates for line items
        for (const [x, value] of Object.entries(this.bankReconItems)) {
          if (this.bankReconItems[x].cleared_date) {
            this.bankReconItems[x].cleared_date = this.datePipe.transform(this.bankReconItems[x].cleared_date, 'MM/dd/yyyy');
          }
          if (this.bankReconItems[x].header_date) {
            this.bankReconItems[x].header_date = this.datePipe.transform(this.bankReconItems[x].header_date, 'MM/dd/yyyy');
          }
        }

        this.bankReconciliationForm.patchValue(this.bankReconciliation, {emitEvent: false});

        // if previous recon items tied to this recon id display them
        if (this.bankReconItems.length > 0) {
          this.loadFormArray(this.bankReconItems);
          this.calcTotals(this.bankReconItems);
        }

        this.vm.buttonsDisabled = false;
        this.disablefields(false);
        this.originalDocument = structuredClone(this.bankReconciliationForm.getRawValue());
        this.isLoaded = true;
      }
    });
  }

  private loadCurrency() {
    this.tableDataService.getData('currency', '?state=active&pageNumber=0&pageSize=999999').subscribe({
      next: (result: ResponseModel) => {
        this.currency = result.Data;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  private loadBank() {
    this.tableDataService.getData('bank', '?state=active&pageNumber=0&pageSize=999999').subscribe({
      next: (result: ResponseModel) => {
        this.bank = result.Data;
        this.isBankLoaded = true;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  private loadCompany() {
    this.tableDataService.getApiListData('company', '?state=active&pageNumber=0&pageSize=999999').subscribe({
      next: (result: ResponseModel) => {
        this.company = result.Data;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  disablefields(disable: boolean) {
    if (disable) {
      this.bankReconciliationForm.get('reconciliation_date')?.disable();
      this.bankReconciliationForm.get('balance')?.disable();
    } else {
      this.bankReconciliationForm.get('reconciliation_date')?.enable();
      this.bankReconciliationForm.get('balance')?.enable();
    }
  }

  statementDateChanged(event = null) {
    this.update();
    // console.log('date changed: ' + event);
  }

  update() {

    // const bankControl = this.bankReconciliationForm.get('bank_id');
    // if (bankControl && bankControl.errors) {
    //   console.log('bank errs:' + bankControl.errors);
    // }
    //
    // const statementDateControl = this.bankReconciliationForm.get('reconciliation_date');
    // if (statementDateControl && statementDateControl.errors) {
    //   console.log('date errors:' , statementDateControl.errors);
    // }

    if (this.bankReconciliationForm.invalid) {

      this.notification.showWarningToast($localize`:Form error(s) exist @@formError(s)Exit:Form error(s) exist`);
      return;
    } else {
      this.vm.buttonsDisabled = true;
      this.disablefields(true);
      this.vm.dateError = false;

      this.tableDataService.getData('bank_reconciliation/recitems',
        '?account_id=' + this.bankReconciliationForm.controls.account_id.value
        + '&toDate=' + this.datePipe.transform(this.bankReconciliationForm.controls.reconciliation_date.value, 'MM/dd/yyyy')
        + '&company_id=' + this.bankReconciliationForm.controls.company_id.value
        + '&currency_id=' + this.bankReconciliationForm.controls.currency_id.value
        + '&bank_id=' + this.bankReconciliationData.bank_id
      )
        .subscribe({
          next: (result) => {
            // hold the previously selected record when we go get more recs
            const saveSelectedItems = [];

            // checks for currently selected for recon is Get data clicked again
            this.bankReconItems.forEach((item: any, index) => {
              const matchingControl = (this.bankReconciliationForm.get('reconItems') as UntypedFormArray).controls.find(control =>
                control.get('header_id')?.value === item.header_id &&
                control.get('detail_id')?.value === item.detail_id &&
                control.get('isReconciled')?.value === true &&
                control.get('datePickerClearedDate')?.value !== null
              );

              if (matchingControl) {
                item.isReconciled = true;
                item.cleared_date = matchingControl.get('datePickerClearedDate')?.value;
                // console.log('Matching control found:', item);
                saveSelectedItems.push(item);
              }
            });

            this.bankReconItems = [];
            this.bankReconItems = result.items;

            if (this.bankReconciliationId === 'new') {
              this.bankReconciliationData = result;
              this.amountToReconcile = this.bankReconciliationData.endingBalance - this.bankReconciliationData.openingBalance;
            }
            // const objectResult = saveSelectedItems.reduce((acc, item) => {
            //   return { ...acc, ...item };
            // }, {});

            let objectResult = {};
            saveSelectedItems.forEach((item) => {
              objectResult = {...objectResult, ...item};
            });

            // console.log('objectResult: ', objectResult);

            // add the saved items to the new array
            for (const [x, value] of Object.entries(saveSelectedItems)) {
              this.bankReconItems.unshift(value);
            }
            // this.bankReconItems.unshift(objectResult);

            // console.log('bankReconItems from update: ', this.bankReconItems);
            this.loadFormArray(this.bankReconItems);
            this.calcTotals(this.bankReconItems);
            this.vm.buttonsDisabled = false;
            this.disablefields(false);

            for (const [x, value] of Object.entries(this.bankReconItems)) {
              if (this.bankReconItems[x].cleared_date) {
                this.bankReconItems[x].cleared_date = this.datePipe.transform(this.bankReconItems[x].cleared_date, 'MM/dd/yyyy');
              }
              if (this.bankReconItems[x].header_date) {
                this.bankReconItems[x].header_date = this.datePipe.transform(this.bankReconItems[x].header_date, 'MM/dd/yyyy');
              }
            }
          },
          error: (error: HttpErrorResponse) => {
            console.log(error);
          }
        });
    }
  }

  onClose() {
    const fallback = '/transactions/bank-reconciliation/bank-reconciliation-list';
    this.nav.backOr(fallback);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.bankReconciliationForm.controls;
  }

  onSave() {
    this.submitted = true;
    this.isSaving = true;
    if (this.bankReconciliationForm.invalid) {
      // console.log('some error in post / patch');
      return;
    }

    this.vm.buttonsDisabled = true;
    this.disablefields(true);

    // if (this.bankReconciliation === undefined) {
    this.bankReconciliation = new BankReconciliationModel();
    // console.log('bankReconciliation is redefined');
    // this.bankReconciliation = new BankReconciliationModel();
    this.bankReconciliation.balance = this.bankReconciliationForm.get('balance').value;
    this.bankReconciliation.account_id = this.bankReconciliationForm.get('account_id').value;
    this.bankReconciliation.reconciled = this.bankReconciliationForm.get('reconciled').value;
    this.bankReconciliation.reconciliation_date = this.datePipe.transform(this.bankReconciliationForm.get('reconciliation_date').value, 'MM/dd/yyyy');
    // this.bankReconciliation.clearedItems = this.clearItemsList();
    //  }

    // this.bankReconciliation.reconItems = this.clearItemsList();

    this.bankReconciliation.clearedItems = this.clearItemsList();

    if (this.bankReconciliationId === 'new') {
      // new
      this.tableDataService.post('bank_reconciliation', this.bankReconciliation).subscribe({
        next: (item: any) => {
          // console.log('post return:', item);
          this.bankReconciliationId = item.id;

          return true;
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
        },
        complete: () => {
          this.bankReconciliationForm.reset(this.bankReconciliationForm.value);
          this.isSaving = false;
          this.submitted = false;
          // reset unsaved-changes snapshot to the just-saved state
          this.originalDocument = structuredClone(this.bankReconciliationForm.getRawValue());
          this.cdr.detectChanges();
        }
      });
    } else {
      // edit
      const postReconHdrData = {
        account_id: this.bankReconciliationForm.get('account_id').value,
        reconciliation_date: this.datePipe.transform(this.bankReconciliationForm.get('reconciliation_date').value, 'MM/dd/yyyy'),
        balance: this.bankReconciliationForm.get('balance').value,
        // company_id: this.bankReconciliationForm.get('company_id').value,
        // currency_id: this.bankReconciliationForm.get('currency_id').value,
        reconciled: this.bankReconciliationForm.get('reconciled').value,
        clearedItems: this.clearItemsList(),
      };
      this.tableDataService.patch('bank_reconciliation', this.bankReconciliationId, postReconHdrData).then(
        (item: any) => {
          // console.log('patched values: ' + JSON.stringify(postReconHdrData));
          // console.log('formvalue: ' + JSON.stringify(this.bankReconciliationForm.value));
          // this.notification.success($localize`:Updated@@updated:Updated`);
          this.vm.buttonsDisabled = false;
          this.isSaving = false;
          this.disablefields(false);
          this.originalDocument = structuredClone(this.bankReconciliationForm.getRawValue());
          return true;
        },
        (error: HttpErrorResponse) => {
          console.log(error);
        }
      );
    }

    // this.saveClearedItems();
    this.submitted = false;

  }

  saveClose() {
    this.onSave();
    this.router.navigate(['transactions/bank-reconciliation/bank-reconciliation-list']).then();
  }

  calcTotals(data: any = null) {
    if (this.bankReconciliation === undefined) {
      return;
    }
    // After loading items, recompute totals based on reconciled flags in the form
    this.recomputeTotals();
    this.isLoaded = true;
  }

  /**
   * Recompute totals strictly from the current form state.
   * - Total Deposits Reconciled: sum of deposit amounts where isReconciled is true and deposit != 0
   * - Total Withdrawals Reconciled: sum of withdrawal amounts where isReconciled is true and withdrawal != 0
   * - Statement to Book Reconciled: statement balance - (deposits - withdrawals)
   */
  private recomputeTotals(): void {
    const marker = this.getDecimalSeparator(LOCALE_ID);
    this.totalDeposits = 0;
    this.totalWithdrawals = 0;
    this.vm.clearedItems = 0;

    const arr = this.bankReconciliationForm?.get('reconItems') as UntypedFormArray;
    if (arr && arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        const grp = arr.at(i) as UntypedFormGroup;
        const isRec = !!grp.get('isReconciled')?.value;
        if (!isRec) {
          continue;
        }
        const depRaw = grp.get('deposit')?.value ?? 0;
        const wdrRaw = grp.get('withdrawal')?.value ?? 0;
        const dep = Number(this.removeThousandsSeparator(depRaw, marker)) || 0;
        const wdr = Number(this.removeThousandsSeparator(wdrRaw, marker)) || 0;
        if (dep !== 0) {
          this.totalDeposits += dep;
        }
        if (wdr !== 0) {
          this.totalWithdrawals += wdr;
        }
      }
    }

    // Net reconciled amount for info (deposits - withdrawals)
    this.vm.clearedItems = (this.totalDeposits - this.totalWithdrawals);

    // Statement balance from the form control if available; fall back to data model
    let statementBalance = 0;
    const balanceCtrlVal = this.bankReconciliationForm?.get('balance')?.value;
    if (balanceCtrlVal !== undefined && balanceCtrlVal !== null && balanceCtrlVal !== '') {
      statementBalance = Number(this.removeThousandsSeparator(balanceCtrlVal, marker)) || Number(balanceCtrlVal) || 0;
    } else if (this.bankReconciliationData?.balance != null) {
      statementBalance = Number(this.bankReconciliationData.balance) || 0;
    }

    // Statement to Book Reconciled per spec
    this.statementToBookVariance = statementBalance - (this.totalDeposits - this.totalWithdrawals);
  }

  statementBalanceChanged(value) {
    // console.log('bal value: ' + value);
    this.bankReconciliationData.balance = value;
    // Recompute variance when statement balance changes
    this.recomputeTotals();
  }

  selectAllCheckboxChange(e: any) {
    if (e.target.checked) {
      this.reconLineItems.controls.forEach((item) => {
        item.get('isReconciled').setValue(true);
        item.get('datePickerClearedDate').setValue(this.datePipe.transform(new Date(), 'MM/dd/yyyy'));
      });
    } else {
      this.reconLineItems.controls.forEach((item) => {
        item.get('isReconciled').setValue(false);
        item.get('datePickerClearedDate').setValue('');
      });
    }
    // Always recompute totals after bulk toggle
    this.recomputeTotals();
  }

  onReconciledCheckboxChange(e: any, deposit: any, withdrawal: any, i: any) {
    if (e.target.checked) {
      this.reconLineItems
        .at(i)
        .get('datePickerClearedDate')
        .patchValue(this.datePipe.transform(new Date(), 'MM/dd/yyyy'));
      this.reconLineItems.at(i).get('isReconciled').patchValue(true);
    } else { // unchecked
      this.reconLineItems.at(i).get('datePickerClearedDate').patchValue('');
      this.reconLineItems.at(i).get('isReconciled').patchValue(false);
      this.cdr.detectChanges();
    }

    // Recompute per spec
    this.recomputeTotals();

    // let user know when balanced: variance equals zero
    if (this.statementToBookVariance === 0) {
      this.notification.showSuccessToast('This account is now reconciled to book');
    }
  }

  clearItemsList(): any[] {
    const clearedItems: any[] = [];
    const reconItems = this.bankReconciliationForm.get('reconItems') as UntypedFormArray;
    for (const i of reconItems.controls) {
      if (i.get('isReconciled').value === true) {
        // console.log('datepick val in if : ' + i.get('datePickerClearedDate').value);
        // console.log('recon chk val in if: ' + i.get('isReconciled').value);
        clearedItems.push({
          cleared_date: new Date(i.get('datePickerClearedDate').value).toISOString(),
          detail_id: i.get('detail_id').value,
          recon_id: this.bankReconciliationId,
          id: i.get('clearedId').value,
        });
      }
    }
    return clearedItems;
  }


  deleteItem() {
    const brClass = this;
    let retMsg = '';
    const messages: string[] = [
      $localize`:Are you sure you want to delete record? @@areyousureyouwanttodeleterecord:Are you sure you want to delete record?`,
      this.bankReconciliation.bank_name,
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.tableDataService.deleteDataById('bank_reconciliation', this.bankReconciliationData.id).subscribe(
          (result) => {
            this.isDeleting = true;
            retMsg = result;
            // this.notification.showSuccessToast($localize`:Deleted Canceled@@deleted:Deleted`);
          },
          (error: HttpErrorResponse) => {
            // this.notification.error($localize`:Error @@error:Error`);
            console.log(error);
          },
          () => {
            this.isDeleting = false;
            this.onClose();
          }
        );
      },
      () => {
        brClass.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }
}
